import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { closePageWindow, usePageWindow } from '@/lib/page-window';

/** Draws the one page window (lib/page-window.ts) over the screen in use. */
export function PageWindowHost() {
  const { t } = useTranslation('common');
  const win = usePageWindow();

  useEffect(() => {
    if (!win) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && closePageWindow();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [win]);

  if (!win) return null;
  return (
    <>
      <div className="fixed inset-0 z-[70] bg-[rgba(15,23,42,0.35)]" onClick={closePageWindow} />
      <div role="dialog" aria-modal="true" aria-label={win.title} className="gen08-window gen08-open z-[71] bg-white" data-testid="page-window">
        <div className="flex items-center justify-between border-b border-border px-4 py-2">
          <h2 className="text-sm font-semibold">{win.title}</h2>
          <button
            type="button"
            onClick={closePageWindow}
            aria-label={t('close', { defaultValue: 'Close' })}
            className="rounded p-1 text-muted-foreground hover:bg-gray-100 hover:text-foreground"
            data-testid="page-window-close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <iframe title={win.title} src={win.url} className="min-h-0 w-full flex-1 border-0" data-testid="page-window-frame" />
      </div>
    </>
  );
}
